import { render, staticRenderFns } from "./SapphireBody.vue?vue&type=template&id=d616612a"
import script from "./SapphireBody.vue?vue&type=script&lang=js"
export * from "./SapphireBody.vue?vue&type=script&lang=js"
import style0 from "./SapphireBody.vue?vue&type=style&index=0&id=d616612a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports